import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ArticleContent from '../../components/articleContent';
import styles from './index.css';
import Header from './Header';
import { goVote } from '../utils/goVote';
import Toast from '../components/Toast';

const Layout = ({ content }) => {
    const { docData } = content;

    const [statusBarHeight, setStatusBarHeight] = useState(0); // 状态栏高度
    const [urlParams, setUrlParams] = useState({}); // 地址参数

    useEffect(() => {
        // 沉浸式
        if (window.grounds && window.grounds.maximization && window.grounds.getStatusBarHeight) {
            const isAndroid = /android/i.test(window.grounds.getDeviceInfo().getOs());
            const ratio = isAndroid ? devicePixelRatio : 1;
            const statusBarHeight = window.grounds.getStatusBarHeight() / ratio;

            window.grounds.maximization();
            setStatusBarHeight(statusBarHeight);
        }
        const { search } = window.location;
        const obj = {};

        for (let item of search.slice(1).split('&')) {
            const [key, value] = item.split('=');

            obj[key] = decodeURI(value);
        }
        setUrlParams(obj);
    }, []);

    const afterVote = voteNum => {
        setUrlParams({
            ...urlParams,
            mynum: parseInt(urlParams.mynum) - parseInt(voteNum),
            num: parseInt(urlParams.num) + parseInt(voteNum),
        });
    };

    const doGoVote = () => {
        const { cateid, questionid, itemid, token, mynum, finish } = urlParams;

        if (finish === 'true') {
            Toast.default({
                content: '助力失败，活动已结束',
            });

            return;
        }

        goVote({
            cateId: cateid,
            questionId: questionid,
            itemId: itemid,
            token,
            voteNum: mynum,
            cb: num => afterVote(num),
        });
    };

    return (
        <div className={styles.container}>
            <Header height={statusBarHeight} />
            <div className={styles.mainImage}>
                <img
                    className={styles.logo}
                    style={{ top: `${statusBarHeight + 4}px` }}
                    src="https://x0.ifengimg.com/ucms/2021_40/528EC8BC64300BE39B1D55E5E79207840156E141_size9_w690_h45.png"
                    alt="logo"
                />
            </div>
            <div className={styles.layout}>
                <div className={styles.top} />
                <div>
                    <div className={styles.voteWp}>
                        <div className={styles.voteInfo}>
                            <span className={styles.name}>{urlParams.name}</span>
                            <span className={styles.num}>{urlParams.num}票</span>
                        </div>
                        <div
                            className={`${urlParams.finish === 'true' ? `${styles.disable_btn}` : `${styles.btn}`}`}
                            onClick={doGoVote}>
                            {urlParams.finish === 'true' ? '已入围' : '为Ta投票'}
                        </div>
                    </div>
                    <div className={styles.content}>
                        <ArticleContent
                            content={docData.contentData}
                            imagesInContent={docData.imagesInContent}
                            pluginData={{}}
                            isBig={false}
                            pageType={docData.type}
                        />
                    </div>
                </div>

                <div className={styles.bottom} />
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
